import { useState } from "react";
import { Info } from "lucide-react";

// A failed load shows an error with Retry, never a 0 that looks like data.
function StatCard({ title, value, sub, description, className = "", loading = false, error = null, onRetry }) {
  // Tap the ⓘ to read the description (phones have no hover).
  const [showInfo, setShowInfo] = useState(false);
  let body = value;
  if (error) {
    body = (
      <span className="text-base">
        {"Couldn't load. "}
        {onRetry ? (
          <button type="button" onClick={onRetry} className="underline">
            Retry
          </button>
        ) : null}
      </span>
    );
  } else if (loading) {
    body = (
      <span
        className="inline-block h-6 w-16 align-middle animate-pulse rounded bg-black/10"
        aria-label="Loading"
      />
    );
  }

  return (
    <div
      className={`relative p-4 rounded-xl shadow-sm border border-gray-100 ${className} transition-colors ${description ? "group" : ""}`}
    >
      <div className="flex items-start justify-between gap-2">
        <p className="text-sm text-black">{title}</p>
        {description ? (
          <button
            type="button"
            onClick={() => setShowInfo((v) => !v)}
            onBlur={() => setShowInfo(false)}
            aria-label={`What is ${title}?`}
            aria-expanded={showInfo}
            className="-m-1 p-1 text-black/50 hover:text-black/80"
          >
            <Info className="w-4 h-4" />
          </button>
        ) : null}
      </div>
      <h2 className="text-xl font-bold text-black">
        {body}
      </h2>
      {sub && !error && !loading ? (
        <p className="text-xs text-gray-700 mt-0.5">{sub}</p>
      ) : null}

      {description && (
        <div className={`absolute top-full left-1/2 transform -translate-x-1/2 mt-2 px-3 py-2 bg-gray-900 text-white text-xs rounded-md shadow-lg ${showInfo ? "opacity-100" : "opacity-0"} group-hover:opacity-100 transition-opacity duration-200 pointer-events-none z-50 w-max max-w-[200px] text-center whitespace-normal`}>
          {description}
          {/* Tooltip Arrow */}
          <div className="absolute bottom-full left-1/2 transform -translate-x-1/2 -mb-px border-4 border-transparent border-b-gray-900"></div>
        </div>
      )}
    </div>
  );
}

export default StatCard;
